import { signal, Signal, WritableSignal } from '@angular/core';

export type Notifier = Signal<number> & { notify: () => void };

export function notifier(): Notifier {
  const notifierImpl = signal(0) as WritableSignal<number> & { notify: () => void };

  notifierImpl.notify = () => notifierImpl.update((n) => n + 1);
  return notifierImpl as Notifier;
}
